export enum RangeTypes {
  Custom = 'custom',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
}
